import React, { Component } from 'react'
import { connect } from 'react-redux'

import Style from './ThreatFeedDetections.module.css'
import LoaderWrapper from '../../common/LoaderWrapper/LoaderWrapper'
import Loading from '../../common/LoaderWrapper/loading'
import Paginator from '../../common/paginator/paginator'
import ThreatFeedStatusMenu from './ThreatFeedStatusMenu'
import { formatThreatFeedDatetime } from '../../../utilities/datetime'
import { loadNextEvents, loadPrevEvents } from '../../../store/entities/events'

// ===========================================================================
// Threat Feed — grid (card) view (PIXMC-6500).
//
// Custom card markup ported from the claude-dashboards mockup: two cards per row, each led
// by the real detection screenshot. Shared events slice, same pagination and Update Status
// wiring as the list — presentation only. Renders inside ThreatFeed's card.
// ===========================================================================

const STATUS_CLASS = {
  'PIXM Verified': Style.statusPixmVerified,
  'Verified Phish': Style.statusVerifiedPhish,
  'AI Suspicious': Style.statusAiSuspicious,
  'Reported Phish': Style.statusReportedPhish,
}
const badgeClass = (status) => STATUS_CLASS[status] || Style.statusDefault

const userName = (e) => e.osUserId || e.osComputerName || e.osuuid || e.email || 'NA'
const screenshotOf = (e) => e.resizedScreenshotURL || e.screenshotURL || e.markedScreenshotURL || null

class ThreatFeedGrid extends Component {
  render() {
    const { events, threatFilters, totalSize, loading, isLastPage, onDetails } = this.props
    const { offset } = threatFilters
    const rows = events.slice(offset, offset + 20)
    // Remount the Paginator on any filter (except offset) change so its cached filters stay
    // fresh — otherwise paging re-sends the previous startTime.
    const pagerKey = [
      threatFilters.startTime, threatFilters.endTime, threatFilters.order,
      threatFilters.brand || '', threatFilters.extensionUserId || '',
      threatFilters.triagedEvent != null ? threatFilters.triagedEvent : '',
      threatFilters.pixmVerified != null ? threatFilters.pixmVerified : '',
      (threatFilters.type || []).join(','),
    ].join('|')

    return (
      <>
        <div className={Style.resultsCount}>
          Results ({rows.length === 0 ? 0 : isLastPage ? offset + rows.length : `More than ${offset + rows.length}`})
        </div>
        <div className={Style.cardBody}>
          {/* Loader overlays the grid only (existing Loading component); content stays
              mounted underneath during filter / sort / page loads. */}
          {loading && <div className={Style.tableLoaderOverlay}><Loading loading={true} /></div>}
          <LoaderWrapper
            loading={false}
            data={rows}
            styles={{ minHeight: '400px' }}
            placeholderText={'No Threats Detected'}
          >
            <>
              <div className={Style.grid}>
                {rows.map((item, i) => {
                  const shot = screenshotOf(item)
                  return (
                    <div className={Style.pcard} key={item.id || i}>
                      {shot ? (
                        <img className={Style.pcardShotImg} src={shot} alt={`${item.brands || 'Phishing'} page screenshot`} />
                      ) : (
                        <div className={Style.pcardShot}>No screenshot</div>
                      )}
                      <div className={Style.pcardHead}>
                        <div>
                          <div className={Style.pcardUser}>{userName(item)}</div>
                          <div className={Style.pcardBrand}>{item.brands || 'NA'}</div>
                        </div>
                        <span className={badgeClass(item.status)}>{item.status}</span>
                      </div>
                      <div className={Style.pcardUrl} title={item.url}>{item.url}</div>
                      <div className={Style.pcardRow}><span className={Style.pcardK}>Opened</span>{formatThreatFeedDatetime(item.detectionTime)}</div>
                      <div className={Style.pcardRow}><span className={Style.pcardK}>Action</span>{item.userAction}</div>
                      <div className={Style.pcardActions}>
                        <ThreatFeedStatusMenu event={item} onAction={this.props.onStatusAction} />
                        <button className={Style.btn} onClick={() => onDetails(item)}>View Details</button>
                      </div>
                    </div>
                  )
                })}
              </div>
              <div className={Style.pager}>
                <Paginator
                  key={pagerKey}
                  onNext={this.props.loadNextEvents}
                  onPrev={this.props.loadPrevEvents}
                  filters={threatFilters}
                  totalSize={totalSize % 21 !== 0 ? events.length : events.length + 1}
                  isLastPage={isLastPage}
                  cacheSize={events.length}
                  from={'incidentGrid'}
                />
              </div>
            </>
          </LoaderWrapper>
        </div>
      </>
    )
  }
}

const mapStateToProps = (state) => ({
  events: state.entities.events.list,
  threatFilters: state.entities.events.threat.filters,
  loading: state.entities.events.loading,
  totalSize: state.entities.events.totalSize,
  isLastPage: state.entities.events.isLastPage,
})

const mapDispatchToProps = (dispatch) => ({
  loadNextEvents: (offset, customerId, defaultCustomerId, isGlobalView) =>
    dispatch(loadNextEvents(offset, customerId, defaultCustomerId, isGlobalView)),
  loadPrevEvents: (offset, customerId, defaultCustomerId, isGlobalView) =>
    dispatch(loadPrevEvents(offset, customerId, defaultCustomerId, isGlobalView)),
})

export default connect(mapStateToProps, mapDispatchToProps)(ThreatFeedGrid)
